import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import { useEffect, useReducer, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  createProductCategory,
  productCategoryData,
  productCategoryDataMange,
  updateProductCategory,
} from "./productCategoryData";
import MaterialTypography from "../../../components/MaterialTypography";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialBox from "../../../components/MaterialBox";

import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";

import Swal from "sweetalert2";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import { useLoading } from "../../../context/LodingContext";

const ProductCategoryForm = () => {
  const [productCategory, dispatch] = useReducer(
    productCategoryDataMange,
    productCategoryData
  );
  const [inputDisble, setInputDisble] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { userId } = useAuthData();
  const { setCirleLoading } = useLoading();

  const formType = location?.state?.type;
  const formValue = location?.state?.data;
  useEffect(() => {
    if (formValue) {
      dispatch({
        value: formValue?.categoryCode,
        name: "categoryCode",
      });
      dispatch({
        value: formValue?.categoryName,
        name: "categoryName",
      });
      dispatch({
        value: formValue?.categoryDescription,
        name: "description",
      });
    }
  }, [formValue]);

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      productCategory.categoryCodeStatus === "success" &&
      productCategory.categoryNameStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAdd = async () => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, createProductCategory, {
        input: {
          user: userId,
          categoryCode: productCategory?.categoryCode,
          categoryName: productCategory?.categoryName,
          categoryDescription: productCategory?.description,
        },
      });

      const success = res?.createProductCategory?.success;
      const message = res?.createProductCategory?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/product-category");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Network Error",
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUpdate = async () => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, updateProductCategory, {
        input: {
          id: formValue?.id,
          categoryCode: productCategory?.categoryCode,
          categoryName: productCategory?.categoryName,
          categoryDescription: productCategory?.description,
        },
      });

      const success = res?.updateProductCategory?.success;
      const message = res?.updateProductCategory?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/product-category");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Network Error",
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Product Category Details"
                    : formType == "edit"
                    ? "Edit Product Category Details"
                    : "View Product Category Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Category Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productCategory?.categoryCode?.toUpperCase()}
                  name="categoryCode"
                  placeholder="Enter Category Code"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "categoryCode" })
                  }
                  error={
                    productCategory.categoryCodeStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    productCategory.categoryCodeStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Category Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productCategory?.categoryName}
                  name="categoryName"
                  placeholder="Enter Category Name"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "categoryName" })
                  }
                  error={
                    productCategory.categoryNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    productCategory.categoryNameStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 12, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Description
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  multiline
                  rows={4}
                  value={productCategory?.description}
                  name="description"
                  placeholder="Enter Category Description"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "description" })
                  }
                  error={
                    productCategory.descriptionStatus === "error" ? true : false
                  }
                  success={
                    productCategory.descriptionStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/product-category")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={formType == "add" ? handleAdd : handleUpdate}
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default ProductCategoryForm;
